import { InjectionToken } from '@angular/core';

export interface ISnackbarService {
  openInfoBar(message: string, action?: string, duration?: number): void;
  openErrorBar(message: string, action?: string, duration?: number): void;
}

export const SNACKBAR_SERVICE = new InjectionToken<ISnackbarService>('SnackbarService');
